var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70831 2.53324V0.625C7.70831 0.279999 7.98831 0 8.33331 0C8.67831 0 8.95831 0.279999 8.95831 0.625V2.53324C11.8822 2.84607 14.1667 5.32784 14.1667 8.33328V10.6567C14.1667 12.3059 14.8892 13.8625 16.1484 14.9275C16.4809 15.2109 16.6667 15.6149 16.6667 16.0417C16.6667 16.8459 16.0126 17.5 15.2083 17.5H11.3955C11.1053 18.9248 9.84266 20 8.33331 20C6.82397 20 5.56136 18.9248 5.27108 17.5H1.45828C0.654144 17.5 0 16.8459 0 16.0417C0 15.6149 0.185852 15.2109 0.509949 14.9333C1.7775 13.8625 2.5 12.3059 2.5 10.6567V8.33328C2.5 5.32783 4.78454 2.84605 7.70831 2.53324ZM8.33331 18.75C9.14849 18.75 9.84347 18.2277 10.1013 17.5H6.56534C6.82321 18.2277 7.51826 18.75 8.33331 18.75ZM1.45828 16.25H5.83331H10.8333H15.2083C15.3217 16.25 15.4167 16.1549 15.4167 16.0417C15.4167 15.9584 15.3708 15.9067 15.3433 15.8833C13.8008 14.5792 12.9167 12.6741 12.9167 10.6567V8.33328C12.9167 5.80582 10.8609 3.75 8.33328 3.75C5.80582 3.75 3.75 5.80582 3.75 8.33328V10.6567C3.75 12.6741 2.86591 14.5792 1.32507 15.8817C1.29578 15.9067 1.25 15.9584 1.25 16.0417C1.25 16.1549 1.34506 16.25 1.45828 16.25Z",
    fill: "#111111"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 5,
    r: 3.5,
    fill: "#FF2525",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/Notification-icon.100255d9a7435fa5c498b22353ddf88b.svg";
export { ForwardRef as ReactComponent };